module.exports = __webpack_public_path__ + "img/contentImg4.f05c439.png";